export const englishLevels = {
  A1: { name: "Вeginner, Elementary", hours: 90, color: "#FFE4CB" },
  A2: { name: "Pre-Intermediate", hours: 90, color: "#FEFFB8" },
  B1: { name: "Intermediate", hours: 120, color: "#D2FFC2" },
  B2: { name: "Upper Intermediate", hours: 120, color: "#D3FFFD" },
  C1: { name: "Advanced ", hours: 140, color: "#CADCFF" },
  C2: { name: "Upper Advanced", hours: 140, color: "#D9C7FF" },
};
